export default __webpack_public_path__ + "static/media/icon_terimauang_active_new.2ea90fcb.svg";